import {FieldDataTypeEnum} from '@docma-mm-core/field/field-data-type.enum';

export class ImportConstants {

  public static AdditionalFieldsdict: {[fieldName: string]: {DataType: number, DefaultWidth: number}} = {
    'Anhänge': {DataType: FieldDataTypeEnum.String, DefaultWidth: 200 },
    'Attachments': {DataType: FieldDataTypeEnum.String, DefaultWidth: 200 },
    'Datum Vorgang': {DataType: FieldDataTypeEnum.DateTime, DefaultWidth: 150 },
    'Date activities': {DataType: FieldDataTypeEnum.DateTime, DefaultWidth: 150 },
    'Status Vorgang': {DataType: FieldDataTypeEnum.Int32, DefaultWidth: 190 },
    'Status activities': {DataType: FieldDataTypeEnum.Int32, DefaultWidth: 190 },
    'Bezeichnung Vorgang': {DataType: FieldDataTypeEnum.String, DefaultWidth: 250 },
    'Description activities': {DataType: FieldDataTypeEnum.String, DefaultWidth: 250 },
    'Termin Vorgang': {DataType: FieldDataTypeEnum.Date, DefaultWidth: 150 },
    'Duedate activities': {DataType: FieldDataTypeEnum.Date, DefaultWidth: 150 },
    'Anhänge Vorgang': {DataType: FieldDataTypeEnum.String, DefaultWidth: 200 },
    'Attachments activities': {DataType: FieldDataTypeEnum.String, DefaultWidth: 200 }
  };

}
